import { useTranslation } from '../../../hooks/useTranslation';
import Badge from '../../badge/Badge';
import './ProductOutOfStockBadge.less';

const ProductOutOfStockBadge = () => {
    const { t } = useTranslation();
    return (
        <Badge className={`bri-ProductOutOfStockBadge`}>
            {t('SOLD_OUT_BADGE')}
        </Badge>
    );
};

export default ProductOutOfStockBadge;
